import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import LangContext from "../../../context/LanguageContext";
import { useForm } from "react-hook-form";
import { CategoryTranslationFormInputs } from "../../../types/FormFields";
import PkgDestinationCategoriesService from "../../../services/PkgDestinationCategories.service";
import { MsgSuccess } from "../../../components/Loaders/MessageLoaders";
import TextEditor from "../../../components/QuillEditor/TextEditior";

interface PropsType {
  category_id: string;
  featuredCagtegory: boolean;
}
interface ApiRES {
  id: string;
  category_title: string;
}

const TranslationForm: React.FC<PropsType> = ({
  category_id,
  featuredCagtegory,
}) => {
  const { lang, lang_id } = useContext(LangContext);

  const [desciption, setDescription] = useState("");
  const [traslationData, setTraslationData] = useState<ApiRES | null>(null);
  const {
    register,
    setValue,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<CategoryTranslationFormInputs>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isFeatured, setIsFeatured] = useState<boolean>(featuredCagtegory);
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
  };
  const onSubmit = handleSubmit(async (data) => {
    try {
      setLoading(true);
      if (!desciption) {
        setError("description", {
          message: "This field is required",
        });
      } else {
        data.description = desciption;
        if (traslationData) {
          const res = await PkgDestinationCategoriesService.updateTranslation(
            traslationData.id,
            data
          );
          MsgSuccess(res.data.message);
        } else {
          const res = await PkgDestinationCategoriesService.AddTranslation(
            data,
            category_id,
            lang_id
          );
          MsgSuccess(res.data.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  });

  const fetchTranslation = async () => {
    try {
      const res = await PkgDestinationCategoriesService.getTranslation(
        category_id,
        lang_id
      );
      if (res.data.record !== null) {
        setValue("category_title", res.data.record.category_title);
        setDescription(res.data.record.description);
      }
      setTraslationData(res.data.record);
    } catch (error) {
      console.log(error);
    }
  };

  const updatePacakgeDestinationImg = async () => {
    try {
      const data: any = {};

      if (selectedFile) data.pkg_category_img = selectedFile;
      if (isFeatured) data.isFeatured = isFeatured;
      const res = await PkgDestinationCategoriesService.UpdatePkgDestCat(
        data,
        category_id
      );
      MsgSuccess(res.data.message);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTranslation();
    console.log(featuredCagtegory);
    setIsFeatured(featuredCagtegory);
  }, []);
  return (
    <div>
      <form
        action=""
        className="border p-4 bg-gray-50"
        onSubmit={(e) => {
          e.preventDefault();
          console.log("inside form submission");
          updatePacakgeDestinationImg();
        }}
      >
        <label htmlFor="img" className="font-semibold">
          Update Pkg Img{" "}
        </label>
        <div className="">
          <input
            type="file"
            id="img"
            className="form-input inputs mt-1"
            // required
            onChange={(e) => handleFileChange(e)}
          />
          <div className="my-4">
            <input
              type="checkbox"
              name=""
              id="feature"
              checked={isFeatured}
              onChange={(e) => setIsFeatured(e.target.checked)}
            />
            <label htmlFor="feature" className="ml-2 cursor-pointer">
              Is Featured?
            </label>
          </div>
          <input
            type="submit"
            value="SUBMIT"
            disabled={loading}
            className="btn btn-primary"
          />
        </div>
      </form>
      <form action="" onSubmit={onSubmit}>
        <div className="flex flex-col space-y-3 my-4">
          <label htmlFor="category">Package Category {`(${lang})`} </label>
          <input
            type="text"
            className="form-input inputs"
            required
            placeholder="Enter a package category...."
            {...register("category_title", { required: true })}
          />
          {errors.category_title && (
            <span className="text-red-500">
              {errors.category_title.message || "This field is required"}
            </span>
          )}

          <div className="mt-5">
            <label htmlFor="category">Package Description {`(${lang})`} </label>
            <TextEditor
              placeholder="Write your description here.."
              onChange={setDescription}
              value={desciption}
            />
            {errors.description && (
              <span className="text-red-500">
                {errors.description.message || "This field is required"}
              </span>
            )}
          </div>
          <div className="my-4">
            <input
              type="submit"
              value={loading ? "Loading" : traslationData ? "Update" : "Submit"}
              disabled={loading}
              className="btn btn-primary"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default TranslationForm;
